import createSetItemExtendedPropertyField from 'owa-mail-store/lib/services/utils/createSetItemExtendedPropertyField';
import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import extendedPropertyType from 'owa-service/lib/factory/extendedPropertyType';
import itemChange from 'owa-service/lib/factory/itemChange';
import itemId from 'owa-service/lib/factory/itemId';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';

export default function createExtendedPropertyRequestBody(
    id: string,
    property: string,
    value: string
) {
    const translationStatusUri = extendedPropertyUri({
        PropertyName: property,
        DistinguishedPropertySetId: 'Common',
        PropertyType: 'String',
    });
    const translationStatusType = extendedPropertyType({
        ExtendedFieldURI: translationStatusUri,
        Value: value,
    });
    const update = createSetItemExtendedPropertyField(translationStatusType);
    const singleItemChange = itemChange({
        Updates: [update],
        ItemId: itemId({ Id: id }),
    });

    return updateItemRequest({
        ItemChanges: [singleItemChange],
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}
